<template>
  <div class="substep-automatically-detect-unusual-activity">
    <div class="substep-header">
      <h3 data-testid="insights-onboarding-substep-title">Automatically detect unusual activity</h3>
      <p>Insights automatically finds abnormal activity levels, apps that generate fake activity, and more.</p>
    </div>
    <div class="substep-body">
      <div class="totals">
        <div class="card members">
          <div class="value">
            {{ totalMembers }}
          </div>
          <div class="description">Members</div>
        </div>

        <div class="card instances">
          <div class="value">
            {{ totalInstances }}
          </div>
          <div class="description">Instances</div>
        </div>

        <div class="card total-time">
          <div class="value">
            {{ totalTime }}
          </div>
          <div class="description">Total time impacted</div>
        </div>
      </div>

      <div class="table-title">Members with unusual activity</div>

      <AppTable
        :table-data="members"
        scrollable
        class="member-table"
      >
        <AppTableColumn
          v-slot="{ row }"
          header="Member"
          name="member"
        >
          <div class="member">
            <AppAvatar
              :avatar="row.avatar"
              size="speck"
            />

            <span
              :title="row.name"
              class="line-clamp-2 w-fit"
              v-text="row.name"
            ></span>
          </div>
        </AppTableColumn>

        <AppTableColumn
          v-slot="{ row }"
          header="This week"
          name="this week"
          cell-classes="weekly min-width w-fit"
          header-classes="weekly"
        >
          <span
            :title="row.weekly_activity"
            class="line-clamp-2 w-fit"
            v-text="row.weekly_activity"
          ></span>
        </AppTableColumn>

        <AppTableColumn
          v-slot="{ row }"
          header="Type"
          name="type"
        >
          <div>
            <span
              :title="row.type"
              class="line-clamp-2 w-fit"
              v-text="row.type"
            ></span>
          </div>
        </AppTableColumn>

        <AppTableColumn
          v-slot="{ row }"
          cell-classes="confidence min-width"
          header-classes="confidence"
          header="Confidence"
          name="confidence"
        >
          <div
            class="unusual-activity-confidence-label"
            :class="row.confidence.toLowerCase()"
          >
            {{ row.confidence }}
          </div>
        </AppTableColumn>
      </AppTable>
    </div>
  </div>
</template>

<script>
import { INSIGHTS } from '~/app_constants';

export default {
  name: 'AutomaticallyDetectUnusualActivity',
  props: {
    members: {
      type: Array,
      required: true,
      validator: (members) => {
        return members.every((member) => {
          return member.name && member.instances;
        });
      },
    },
    totalMembers: {
      type: Number,
      default: 0,
    },
    totalInstances: {
      type: Number,
      default: 0,
    },
    totalTime: {
      type: String,
      default: '0:00',
    },
  },
  computed: {
    INSIGHTS() {
      return INSIGHTS;
    },
  },
  beforeMount() {
    this.$emit('completeSubstep');
  },
};
</script>
